// extracted by mini-css-extract-plugin
export var button = "_10-4";
export var hasDarkBackground = "_10-7";
export var hasLightBackground = "_10-6";
export var iconWrapper = "_10-0";
export var large = "_10-2";
export var medium = "_10-1";
export var small = "_10-5";
export var xsmall = "_10-3";